export const API_SERVER_URL =
  process.env.REACT_APP_API_SERVER_URL || 'http://localhost:5000';
export const MAIN_PATH = process.env.REACT_APP_MAIN_PATH || '/';
export const LOGIN_PATH = process.env.REACT_APP_LOGIN_PATH || '/login';
